export const handleImagePaste = async (e, acceptedTypes) => {
  const clipboardData = e.clipboardData;
  if (!clipboardData) return null;

  const items = clipboardData.items;
  let imageItem = null;
  let textItem = null;

  for (let i = 0; i < items.length; i++) {
    if (items[i].type.startsWith("image/")) {
      imageItem = items[i];
      break; // Prioritize actual image
    }
    if (items[i].type === "text/plain") {
      textItem = items[i];
    }
  }

  // Helper to check MIME type against accepted types
  const isValidType = (mimeType) => {
    if (!acceptedTypes) return true;
    const acceptArray = acceptedTypes.split(',').map(t => t.trim().toLowerCase());
    
    // image/*
    if (acceptArray.includes('image/*') && mimeType.startsWith('image/')) return true;
    
    // exact match or extension match
    for (const accept of acceptArray) {
      if (accept === mimeType) return true;
      if (accept.startsWith('.') && mimeType.includes(accept.substring(1))) return true;
      // Map common extensions
      if (accept === '.jpg' && mimeType === 'image/jpeg') return true;
    }
    return false;
  };

  if (imageItem) {
    const file = imageItem.getAsFile();
    if (!file) throw new Error("Failed to read image from clipboard");
    if (!isValidType(file.type)) {
      throw new Error("Unsupported image format pasted.");
    }
    
    // Ensure it has a valid name based on mime type if generic
    let ext = file.type.split('/')[1] || 'png';
    if (ext === 'jpeg') ext = 'jpg';
    
    let fileName = file.name;
    if (fileName === 'image.png' || !fileName || fileName === 'image') {
      fileName = `pasted-image.${ext}`;
    }
    
    // Create new file with specific name to be safe
    return new File([file], fileName, { type: file.type });
  }

  if (textItem) {
    // Return a promise to handle async fetching
    return new Promise((resolve, reject) => {
      textItem.getAsString(async (text) => {
        const url = text.trim();
        // Check if it's a typical image URL
        if (url.match(/^https?:\/\/.+\.(jpg|jpeg|png|webp|gif)(\?.*)?$/i)) {
          try {
            const response = await fetch(url);
            if (!response.ok) throw new Error("Network response was not ok");
            const blob = await response.blob();
            
            if (!blob.type.startsWith("image/")) {
              return reject(new Error("URL does not point to a valid image"));
            }
            if (!isValidType(blob.type)) {
              return reject(new Error("Unsupported image format from URL."));
            }
            
            let ext = blob.type.split('/')[1] || 'png';
            if (ext === 'jpeg') ext = 'jpg';
            const fileName = `pasted-image.${ext}`;
            resolve(new File([blob], fileName, { type: blob.type }));
          } catch (error) {
            reject(new Error("Unable to load this image URL. Please download the image or use Ctrl+V with the image itself."));
          }
        } else {
          // Not an image URL, do nothing
          resolve(null);
        }
      });
    });
  }

  return null;
};
